import React from 'react';
import { SectionHeading } from './SectionHeading';
const TEMPLE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/576a32cd-f02a-4952-9378-6ee6a8d946fe.jpg';
interface TrajectoryProps {
  showConsultationCount: boolean;
}
export function Trajectory({
  showConsultationCount
}: TrajectoryProps) {
  return <section aria-labelledby="templo-title" className="relative border-t border-silver/10 bg-indigo-deep py-20 sm:py-28" data-id="element-186" data-mp="1wgrgibagqm4e">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-187" data-mp="yshall7k3e80">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-188" data-mp="13u6qbe5q4g2f">
          <div className="relative overflow-hidden rounded-2xl border border-silver/15 shadow-card" data-id="element-189" data-mp="18s85ho013v8m">
            <img src={TEMPLE_IMAGE} alt="Interior de un templo espiritual en penumbra con arcos de piedra, velas encendidas en candelabros de plata y un altar con cartas de tarot y amatistas" className="h-full w-full object-cover" loading="lazy" data-id="element-190" data-mp="1djhy8xgvjeoq" />
            <div aria-hidden="true" className="absolute inset-0 bg-violet-deep/20 mix-blend-multiply" data-id="element-191" data-mp="2mazxhiavqnb3" />
          </div>

          <div data-id="element-192" data-mp="2cm9nbj5ort10">
            <SectionHeading id="templo-title" eyebrow="En Estados Unidos desde 1983" title="TEMPLO DE AYUDA" align="left" data-id="element-193" data-mp="2clq1vsgtumi8">
              <div className="space-y-5 text-[0.98rem] leading-relaxed text-silver sm:text-lg" data-id="element-194" data-mp="23mcv57k38c17">
                <p data-id="element-195" data-mp="1ym77e2gxv9oe">
                  Desde 1983, nuestro Templo de Ayuda Espiritual ofrece consultas
                  y prácticas tradicionales para personas interesadas en
                  orientación espiritual y rituales personalizados.
                </p>
                <p data-id="element-196" data-mp="1poerox7b200h">
                  Contamos con una trayectoria de consultas y prácticas
                  espirituales realizadas de manera personalizada.
                </p>
              </div>
            </SectionHeading>

            <dl className="mt-10 grid gap-px overflow-hidden rounded-xl border border-silver/15 bg-silver/10 sm:grid-cols-2" data-id="element-197" data-mp="1hdo36lm7fe7j">
              <div className="bg-carbon p-6" data-id="element-198" data-mp="1m565bczyrku3">
                <dt className="text-[0.68rem] font-medium uppercase tracking-[0.22em] text-silver/70" data-id="element-199" data-mp="1m5z7e0nz9m5w">
                  Trayectoria
                </dt>
                <dd className="mt-3 font-display text-3xl font-light text-frost" data-id="element-200" data-mp="1cfcsy9rzz1os">
                  Desde 1983
                </dd>
              </div>
              {showConsultationCount ? <div className="bg-carbon p-6" data-id="element-201" data-mp="251xolmfi9zy5">
                  <dt className="text-[0.68rem] font-medium uppercase tracking-[0.22em] text-silver/70" data-id="element-202" data-mp="250mi3euoee3c">
                    Consultas y rituales
                  </dt>
                  <dd className="mt-3 font-display text-3xl font-light text-frost" data-id="element-203" data-mp="1w0r4l3dne705">
                    Más de 14,000
                  </dd>
                  <p className="mt-2 text-xs leading-relaxed text-silver/70" data-id="element-204" data-mp="kn5glljiybg7">
                    Consultas y rituales realizados a lo largo de nuestra
                    trayectoria.
                  </p>
                </div> : <div className="bg-carbon p-6" data-id="element-205" data-mp="83rorwqjv7ya">
                  <dt className="text-[0.68rem] font-medium uppercase tracking-[0.22em] text-silver/70" data-id="element-206" data-mp="m4arcoc8xlt2">
                    Atención
                  </dt>
                  <dd className="mt-3 font-display text-3xl font-light text-frost" data-id="element-207" data-mp="h5r6ysdawi2t">
                    Personalizada
                  </dd>
                  <p className="mt-2 text-xs leading-relaxed text-silver/70" data-id="element-208" data-mp="3klybf13jijcn">
                    Cada consulta se aborda según las circunstancias de cada
                    persona.
                  </p>
                </div>}
            </dl>
          </div>
        </div>
      </div>
    </section>;
}